import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {PaletaCores, PaletaPreset} from '../../../../shared/components/seletor-paletas/seletor-paletas.component';
import {TemaPersonalizadoService} from '../../../../services/tema-personalizado.service';
import {EmpresasService} from '../../../../superadmin/services/empresas.service';
import {ConstantsService} from '../../../ConstantsService';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-step-tema',
  templateUrl: './step-tema.component.html',
  styleUrls: ['./step-tema.component.scss']
})
export class StepTemaComponent implements OnInit, OnChanges {
  @Input() empresa: any = {};
  @Input() temaSelecionadoInicial: string | null = null;
  @Output() onConcluido = new EventEmitter<string>();
  @Output() onVoltar = new EventEmitter<void>();
  @Output() onPular = new EventEmitter<void>();

  @ViewChild('iframePreview') iframePreview: ElementRef<HTMLIFrameElement>;

  ativando = false;
  mostrarCoresAvancadas = false;
  paletaAtual: PaletaPreset | null = null;
  urlPreview: SafeResourceUrl = null;
  iframeCarregado = false;
  private pendingPreview = false;

  cores: PaletaCores = {
    corPrimaria: '#059669',
    corSecundaria: '#10B981',
    corFundo: '#F0FDF4',
    corFundoCard: '#FFFFFF',
    corTexto: '#1A1A1A',
    corBotaoCta: '#059669'
  };

  // Cores extras do tema (editaveis)
  tema = {
    corFundoDoSite: '#FFFFFF',
    corFundoElementos: '#FFFFFF',
    corTextoPrimaria: '#1A1A1A',
    corTextoSecundaria: '#6B7280',
    corTextoTopo: '#1A1A1A',
    corTextoFundo: '#1A1A1A',
    corTextoBotao: '#FFFFFF',
    corPreco: '#059669',
    corPrecoAdicional: '#059669',
    corTextoPrecoAdicional: '#FFFFFF',
    corBorda: '#E5E7EB',
    corDestaque: '#059669',
    corHover: '#10B981',
    corTextoRodape: '#1A1A1A',
    corFundoRodape: '#F0FDF4',
    corBordaRodape: '#E5E7EB',
    corItemAtivoRodape: '#059669',
    corBotaoMaisMenosRodape: '#6B7280',
    corFundoCarrinho: '#059669',
    corTextoCarrinho: '#FFFFFF',
    corTexto: '#1A1A1A'
  };

  constructor(
    private temaService: TemaPersonalizadoService,
    private empresasService: EmpresasService,
    private constantsService: ConstantsService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.atualizarUrlPreview();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['empresa'] && !this.urlPreview) {
      this.atualizarUrlPreview();
    }
  }

  private atualizarUrlPreview() {
    const url = environment.production && this.empresa?.dominio
      ? `https://${this.empresa.dominio}.meucardapio.ai?mobile=true&t=${Date.now()}`
      : `${window.location.origin}/loja?mobile=true&t=${Date.now()}`;
    this.urlPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  onPaletaHover(paleta: PaletaPreset | null) {
    if (paleta) {
      this.enviarPaletaParaPreview(paleta);
    } else if (this.paletaAtual) {
      this.enviarPaletaParaPreview(this.paletaAtual);
    } else {
      this.enviarParaPreview();
    }
  }

  private enviarPaletaParaPreview(p: PaletaPreset) {
    const iframe = this.iframePreview?.nativeElement;
    if (!iframe?.contentWindow) return;

    iframe.contentWindow.postMessage({
      tipo: 'atualizacao-tema',
      todosValores: {
        corFundo: p.corFundo,
        corTextoFundo: p.corTextoFundo,
        corTextoTopo: p.corTextoTopo,
        corTextoPrimaria: p.corTextoPrimaria,
        corTextoSecundaria: p.corTextoSecundaria,
        corBotao: p.corBotaoCta || p.corPrimaria,
        corTextoBotao: p.corTextoBotao,
        corPreco: p.corPreco,
        corPrecoAdicional: p.corPrecoAdicional,
        corTextoPrecoAdicional: p.corTextoPrecoAdicional,
        corFundoDoSite: p.corFundoDoSite,
        corFundoElementos: p.corFundoElementos,
        corBorda: p.corBorda,
        corDestaque: p.corDestaque,
        corHover: p.corHover,
        corTexto: p.corTexto,
        corTextoRodape: p.corTextoRodape,
        corFundoRodape: p.corFundoRodape,
        corBordaRodape: p.corBordaRodape,
        corItemAtivoRodape: p.corItemAtivoRodape,
        corBotaoMaisMenosRodape: p.corBotaoMaisMenosRodape,
        corFundoCarrinho: p.corFundoCarrinho,
        corTextoCarrinho: p.corTextoCarrinho
      }
    }, '*');
  }

  onPaletaSelecionada(paleta: PaletaPreset | null) {
    this.paletaAtual = paleta;
    if (!paleta) return;
    // Preenche todas as cores extras da paleta
    this.tema.corFundoDoSite = paleta.corFundoDoSite;
    this.tema.corFundoElementos = paleta.corFundoElementos;
    this.tema.corTextoPrimaria = paleta.corTextoPrimaria;
    this.tema.corTextoSecundaria = paleta.corTextoSecundaria;
    this.tema.corTextoTopo = paleta.corTextoTopo;
    this.tema.corTextoFundo = paleta.corTextoFundo;
    this.tema.corTextoBotao = paleta.corTextoBotao;
    this.tema.corPreco = paleta.corPreco;
    this.tema.corPrecoAdicional = paleta.corPrecoAdicional;
    this.tema.corTextoPrecoAdicional = paleta.corTextoPrecoAdicional;
    this.tema.corBorda = paleta.corBorda;
    this.tema.corDestaque = paleta.corDestaque;
    this.tema.corHover = paleta.corHover;
    this.tema.corTextoRodape = paleta.corTextoRodape;
    this.tema.corFundoRodape = paleta.corFundoRodape;
    this.tema.corBordaRodape = paleta.corBordaRodape;
    this.tema.corItemAtivoRodape = paleta.corItemAtivoRodape;
    this.tema.corBotaoMaisMenosRodape = paleta.corBotaoMaisMenosRodape;
    this.tema.corFundoCarrinho = paleta.corFundoCarrinho;
    this.tema.corTextoCarrinho = paleta.corTextoCarrinho;
    this.tema.corTexto = paleta.corTexto;
  }

  onIframeLoad() {
    // Delay para esperar o Angular da loja inicializar e setar as variaveis CSS
    // Depois reenviamos nossos valores por cima
    setTimeout(() => {
      this.iframeCarregado = true;
      this.enviarParaPreview();
    }, 1500);
  }

  onCoresAlteradas(cores: PaletaCores) {
    this.cores = cores;
    this.enviarParaPreview();
  }

  onCorExtraAlterada() {
    this.enviarParaPreview();
  }

  private enviarParaPreview() {
    if (!this.iframeCarregado) {
      this.pendingPreview = true;
      return;
    }

    const iframe = this.iframePreview?.nativeElement;
    if (!iframe?.contentWindow) return;

    iframe.contentWindow.postMessage({
      tipo: 'atualizacao-tema',
      todosValores: this.montarTema()
    }, '*');
  }

  private montarTema(): any {
    return {
      corFundo: this.cores.corFundo,
      corTextoFundo: this.tema.corTextoFundo,
      corTextoTopo: this.tema.corTextoTopo,
      corTextoPrimaria: this.tema.corTextoPrimaria,
      corTextoSecundaria: this.tema.corTextoSecundaria,
      corBotao: this.cores.corBotaoCta,
      corTextoBotao: this.tema.corTextoBotao,
      corPreco: this.tema.corPreco,
      corPrecoAdicional: this.tema.corPrecoAdicional,
      corTextoPrecoAdicional: this.tema.corTextoPrecoAdicional,
      corFundoDoSite: this.tema.corFundoDoSite,
      corFundoElementos: this.tema.corFundoElementos,
      corBorda: this.tema.corBorda,
      corDestaque: this.tema.corDestaque,
      corHover: this.tema.corHover,
      corTexto: this.tema.corTexto,
      corTextoRodape: this.tema.corTextoRodape,
      corFundoRodape: this.tema.corFundoRodape,
      corBordaRodape: this.tema.corBordaRodape,
      corItemAtivoRodape: this.tema.corItemAtivoRodape,
      corBotaoMaisMenosRodape: this.tema.corBotaoMaisMenosRodape,
      corFundoCarrinho: this.tema.corFundoCarrinho,
      corTextoCarrinho: this.tema.corTextoCarrinho
    };
  }

  async avancar() {
    if (this.ativando) return;
    this.ativando = true;

    try {
      const tema: any = {nome: 'Tema do Wizard', ...this.montarTema()};
      const temaCriado = await this.temaService.crieTema(tema);
      if (temaCriado && temaCriado.id) {
        await this.empresasService.ativarTema(true, String(temaCriado.id));
        const empresaAtualizada = await this.empresasService.logada();
        this.constantsService.mudouEmpresa(empresaAtualizada);
      }
      this.onConcluido.emit('personalizado');
    } catch (e) {
      console.error('[Wizard] Erro ao criar/ativar tema:', e);
      this.onConcluido.emit('erro');
    } finally {
      this.ativando = false;
    }
  }

  voltar() {
    this.onVoltar.emit();
  }

  pular() {
    this.onPular.emit();
  }
}
